import { useEffect } from "react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

export const Route = createFileRoute('/')({
  component: RootRedirect,
})

function RootRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate({ to: '/home' })
  }, [navigate])

  return null
}
